/**
 * Import des styles et des modules
 * ****************************************
 */
import "../sass/style.scss";
import StoreLocator from "./modules/StoreLocator";
import Sliders from "./modules/Sliders";
import {visibleFilters} from "./modules/StoreLocator/ui/filters";
import {hidePanel} from "./modules/StoreLocator/ui/panel";

function doOnDocumentLoaded() {
    loaderInit();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", doOnDocumentLoaded);
} else {
    doOnDocumentLoaded();
}

/**
 * Initialisation des modules
 * ******************************
 */
function loaderInit() {
    StoreLocator();
    hidePanel();
    visibleFilters();
    Sliders();
}
